var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7832 14.9219C12.3333 14.9219 12.799 15.3841 12.8037 15.9561C12.799 16.5328 12.3333 17 11.7832 17C11.2191 17 10.7534 16.5328 10.7627 15.9561C10.7534 15.3841 11.2191 14.9219 11.7832 14.9219Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.998 7C13.7741 7.00014 15 8.01578 15 9.61719C14.9999 10.7132 14.4634 11.4279 13.6104 11.9521C12.846 12.4239 12.5297 12.8913 12.5156 13.9062V14.0303H10.9717V13.9062C10.9811 12.1858 11.4571 11.6619 12.2822 11.1328C12.851 10.7706 13.2792 10.3175 13.2793 9.64551C13.2793 8.88764 12.7062 8.40625 11.9883 8.40625C11.331 8.40628 10.697 8.83538 10.6504 9.73145H9C9.05128 7.92496 10.371 7 11.998 7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoQuestion);
export default __webpack_public_path__ + "static/media/info_question.8bbb5fd8b22a7f71b40724f41765c4e2.svg";
export { ForwardRef as ReactComponent };